module.exports = __webpack_public_path__ + "img/banner.894faf7b.jpg";